export const INTENCITY_ATTRIBUTE_NAME = 'INTENSITY';
export const FORMAT_ATTRIBUTE_NAME = 'FORMAT';
export const SHORT_ATTRIBUTE_NAME = 'SHORTNAME';
export const CUPSIZE_ATTRIBUTE_NAME = 'CUPSIZE';
export const MAXINTENSITY_ATTRIBUTE_NAME = 'MAXINTENSITY';
export const ISCAPSULEREQUIRE_ATTRIBUTE_NAME = 'CAPSULESR';
export const ISINTENSITYREQUIRE_ATTRIBUTE_NAME = 'INTENSITYR';
export const COMPATABILITY_ATTRIBUTE_NAME = 'COMPATIBILITY';
export const DESCRIPTION_ATTRIBUTE_NAME = 'DESCRIPTION';
